import React from "react";
import { TagSetOrEditCustomFieldPage } from "./TagSetOrEditCustomFieldPage";
interface TenantTagSetPageProps {
    spaceId: string;
    tagSetId: string;
}
export function TenantTagSetPage({ tagSetId, spaceId }: TenantTagSetPageProps) {
    return <TagSetOrEditCustomFieldPage tagSetId={tagSetId} spaceId={spaceId}/>;
}
